export default "<div class=\"camera-badge\">\n  <span [ngStyle]=\"{'background': color}\"></span>\n</div>\n"